import { ReactComponent as ImageIcon } from '../../assets/images/icons/ic-image.svg';
import { ReactComponent as TextIcon } from '../../assets/images/icons/ic-text.svg';
import { ReactComponent as CursorIcon } from '../../assets/images/icons/ic-cursor.svg';
import styles from './BuilderInspector.module.css';

const icons = { image: ImageIcon, text: TextIcon, cta: CursorIcon };

export default function BuilderInspectorHeader({ type, title, description, badge }) {
    const Icon = icons[type];
    return <header className={styles.header}>
        <span className={styles.icon}>{Icon && <Icon aria-hidden="true" />}</span>
        <div className={styles.heading}><h3>{title}</h3>{description && <p>{description}</p>}</div>
        {badge && <span className={styles.badge}>{badge}</span>}
    </header>;
}
